import { css } from '@emotion/react';
import type { CommonHTMLAttributes } from '@frontend/types';
import { useThemeValues } from '../../../hooks';
import { styles } from '../../../styles';

type Props = CommonHTMLAttributes & {
  children: React.ReactNode;
  className?: string;
};

export const FullscreenModalBody = ({ children, ...rest }: Props) => {
  const theme = useThemeValues();
  return (
    <div
      css={[
        css`
          flex: 1;
          overflow-y: auto;
          padding: ${theme.spacing(2)};
          text-align: left;
        `,
        styles.smallScrollbar(theme),
      ]}
      {...rest}
    >
      {children}
    </div>
  );
};
